import { Component } from "@angular/core";

@Component({
  selector: 'pg-plano-detalhe',
  templateUrl: './plano-detalhe.page.html',
  styleUrls: ['./plano-detalhe.page.scss']
})
export class PlanoDetalhePage {

  constructor(){
  }
}